export const countryNames = [
  { value: "Afghanistan", name: "Afghanistan", code: "af" },
  { value: "Albania", name: "Albania", code: "al" },
  { value: "Algeria", name: "Algeria", code: "dz" },
  { value: "Andorra", name: "Andorra", code: "ad" },
  { value: "Angola", name: "Angola", code: "ao" },
  { value: "Antigua and Barbuda", name: "Antigua and Barbuda", code: "ag" },
  { value: "Argentina", name: "Argentina", code: "ar" },
  { value: "Armenia", name: "Armenia", code: "am" },
  { value: "Australia", name: "Australia", code: "au" },
  { value: "Austria", name: "Austria", code: "at" },
  { value: "Azerbaijan", name: "Azerbaijan", code: "az" },
  { value: "Bahamas", name: "Bahamas", code: "bs" },
  { value: "Bahrain", name: "Bahrain", code: "bh" },
  { value: "Bangladesh", name: "Bangladesh", code: "bd" },
  { value: "Barbados", name: "Barbados", code: "bb" },
  { value: "Belarus", name: "Belarus", code: "by" },
  { value: "Belgium", name: "Belgium", code: "be" },
  { value: "Belize", name: "Belize", code: "bz" },
  { value: "Benin", name: "Benin", code: "bj" },
  { value: "Bhutan", name: "Bhutan", code: "bt" },
  { value: "Bolivia", name: "Bolivia", code: "bo" },
  { value: "Bosnia and Herzegovina", name: "Bosnia and Herzegovina", code: "ba" },
  { value: "Botswana", name: "Botswana", code: "bw" },
  { value: "Brazil", name: "Brazil", code: "br" },
  { value: "Brunei", name: "Brunei", code: "bn" },
  { value: "Bulgaria", name: "Bulgaria", code: "bg" },
  { value: "Burkina Faso", name: "Burkina Faso", code: "bf" },
  { value: "Burundi", name: "Burundi", code: "bi" },
  { value: "Cabo Verde", name: "Cabo Verde", code: "cv" },
  { value: "Cambodia", name: "Cambodia", code: "kh" },
  { value: "Cameroon", name: "Cameroon", code: "cm" },
  { value: "Canada", name: "Canada", code: "ca" },
  { value: "Central African Republic", name: "Central African Republic", code: "cf" },
  { value: "Chad", name: "Chad", code: "td" },
  { value: "Chile", name: "Chile", code: "cl" },
  { value: "China", name: "China", code: "cn" },
  { value: "Colombia", name: "Colombia", code: "co" },
  { value: "Comoros", name: "Comoros", code: "km" },
  { value: "Congo (Congo-Brazzaville)", name: "Congo (Congo-Brazzaville)", code: "cg" },
  { value: "Congo (DRC)", name: "Congo (DRC)", code: "cd" },
  { value: "Costa Rica", name: "Costa Rica", code: "cr" },
  { value: "Croatia", name: "Croatia", code: "hr" },
  { value: "Cuba", name: "Cuba", code: "cu" },
  { value: "Cyprus", name: "Cyprus", code: "cy" },
  { value: "Czechia", name: "Czechia", code: "cz" },
  { value: "Denmark", name: "Denmark", code: "dk" },
  { value: "Djibouti", name: "Djibouti", code: "dj" },
  { value: "Dominica", name: "Dominica", code: "dm" },
  { value: "Dominican Republic", name: "Dominican Republic", code: "do" },
  { value: "Ecuador", name: "Ecuador", code: "ec" },
  { value: "Egypt", name: "Egypt", code: "eg" },
  { value: "El Salvador", name: "El Salvador", code: "sv" },
  { value: "Equatorial Guinea", name: "Equatorial Guinea", code: "gq" },
  { value: "Eritrea", name: "Eritrea", code: "er" },
  { value: "Estonia", name: "Estonia", code: "ee" },
  { value: "Eswatini", name: "Eswatini", code: "sz" },
  { value: "Ethiopia", name: "Ethiopia", code: "et" },
  { value: "Fiji", name: "Fiji", code: "fj" },
  { value: "Finland", name: "Finland", code: "fi" },
  { value: "France", name: "France", code: "fr" },
  { value: "Gabon", name: "Gabon", code: "ga" },
  { value: "Gambia", name: "Gambia", code: "gm" },
  { value: "Georgia", name: "Georgia", code: "ge" },
  { value: "Germany", name: "Germany", code: "de" },
  { value: "Ghana", name: "Ghana", code: "gh" },
  { value: "Greece", name: "Greece", code: "gr" },
  { value: "Grenada", name: "Grenada", code: "gd" },
  { value: "Guatemala", name: "Guatemala", code: "gt" },
  { value: "Guinea", name: "Guinea", code: "gn" },
  { value: "Guinea-Bissau", name: "Guinea-Bissau", code: "gw" },
  { value: "Guyana", name: "Guyana", code: "gy" },
  { value: "Haiti", name: "Haiti", code: "ht" },
  { value: "Honduras", name: "Honduras", code: "hn" },
  { value: "Hungary", name: "Hungary", code: "hu" },
  { value: "Iceland", name: "Iceland", code: "is" },
  { value: "India", name: "India", code: "in" },
  { value: "Indonesia", name: "Indonesia", code: "id" },
  { value: "Iran", name: "Iran", code: "ir" },
  { value: "Iraq", name: "Iraq", code: "iq" },
  { value: "Ireland", name: "Ireland", code: "ie" },
  { value: "Israel", name: "Israel", code: "il" },
  { value: "Italy", name: "Italy", code: "it" },
  { value: "Jamaica", name: "Jamaica", code: "jm" },
  { value: "Japan", name: "Japan", code: "jp" },
  { value: "Jordan", name: "Jordan", code: "jo" },
  { value: "Kazakhstan", name: "Kazakhstan", code: "kz" },
  { value: "Kenya", name: "Kenya", code: "ke" },
  { value: "Kiribati", name: "Kiribati", code: "ki" },
  { value: "Kuwait", name: "Kuwait", code: "kw" },
  { value: "Kyrgyzstan", name: "Kyrgyzstan", code: "kg" },
  { value: "Laos", name: "Laos", code: "la" },
  { value: "Latvia", name: "Latvia", code: "lv" },
  { value: "Lebanon", name: "Lebanon", code: "lb" },
  { value: "Lesotho", name: "Lesotho", code: "ls" },
  { value: "Liberia", name: "Liberia", code: "lr" },
  { value: "Libya", name: "Libya", code: "ly" },
  { value: "Liechtenstein", name: "Liechtenstein", code: "li" },
  { value: "Lithuania", name: "Lithuania", code: "lt" },
  { value: "Luxembourg", name: "Luxembourg", code: "lu" },
  { value: "Madagascar", name: "Madagascar", code: "mg" },
  { value: "Malawi", name: "Malawi", code: "mw" },
  { value: "Malaysia", name: "Malaysia", code: "my" },
  { value: "Maldives", name: "Maldives", code: "mv" },
  { value: "Mali", name: "Mali", code: "ml" },
  { value: "Malta", name: "Malta", code: "mt" },
  { value: "Marshall Islands", name: "Marshall Islands", code: "mh" },
  { value: "Mauritania", name: "Mauritania", code: "mr" },
  { value: "Mauritius", name: "Mauritius", code: "mu" },
  { value: "Mexico", name: "Mexico", code: "mx" },
  { value: "Micronesia", name: "Micronesia", code: "fm" },
  { value: "Moldova", name: "Moldova", code: "md" },
  { value: "Monaco", name: "Monaco", code: "mc" },
  { value: "Mongolia", name: "Mongolia", code: "mn" },
  { value: "Montenegro", name: "Montenegro", code: "me" },
  { value: "Morocco", name: "Morocco", code: "ma" },
  { value: "Mozambique", name: "Mozambique", code: "mz" },
  { value: "Myanmar", name: "Myanmar", code: "mm" },
  { value: "Namibia", name: "Namibia", code: "na" },
  { value: "Nauru", name: "Nauru", code: "nr" },
  { value: "Nepal", name: "Nepal", code: "np" },
  { value: "Netherlands", name: "Netherlands", code: "nl" },
  { value: "New Zealand", name: "New Zealand", code: "nz" },
  { value: "Nicaragua", name: "Nicaragua", code: "ni" },
  { value: "Niger", name: "Niger", code: "ne" },
  { value: "Nigeria", name: "Nigeria", code: "ng" },
  { value: "North Korea", name: "North Korea", code: "kp" },
  { value: "North Macedonia", name: "North Macedonia", code: "mk" },
  { value: "Norway", name: "Norway", code: "no" },
  { value: "Oman", name: "Oman", code: "om" },
  { value: "Pakistan", name: "Pakistan", code: "pk" },
  { value: "Palau", name: "Palau", code: "pw" },
  { value: "Palestine", name: "Palestine", code: "ps" },
  { value: "Panama", name: "Panama", code: "pa" },
  { value: "Papua New Guinea", name: "Papua New Guinea", code: "pg" },
  { value: "Paraguay", name: "Paraguay", code: "py" },
  { value: "Peru", name: "Peru", code: "pe" },
  { value: "Philippines", name: "Philippines", code: "ph" },
  { value: "Poland", name: "Poland", code: "pl" },
  { value: "Portugal", name: "Portugal", code: "pt" },
  { value: "Qatar", name: "Qatar", code: "qa" },
  { value: "Romania", name: "Romania", code: "ro" },
  { value: "Russia", name: "Russia", code: "ru" },
  { value: "Rwanda", name: "Rwanda", code: "rw" },
  { value: "Saint Kitts and Nevis", name: "Saint Kitts and Nevis", code: "kn" },
  { value: "Saint Lucia", name: "Saint Lucia", code: "lc" },
  { value: "Saint Vincent and the Grenadines", name: "Saint Vincent and the Grenadines", code: "vc" },
  { value: "Samoa", name: "Samoa", code: "ws" },
  { value: "San Marino", name: "San Marino", code: "sm" },
  { value: "Sao Tome and Principe", name: "Sao Tome and Principe", code: "st" },
  { value: "Saudi Arabia", name: "Saudi Arabia", code: "sa" },
  { value: "Senegal", name: "Senegal", code: "sn" },
  { value: "Serbia", name: "Serbia", code: "rs" },
  { value: "Seychelles", name: "Seychelles", code: "sc" },
  { value: "Sierra Leone", name: "Sierra Leone", code: "sl" },
  { value: "Singapore", name: "Singapore", code: "sg" },
  { value: "Slovakia", name: "Slovakia", code: "sk" },
  { value: "Slovenia", name: "Slovenia", code: "si" },
  { value: "Solomon Islands", name: "Solomon Islands", code: "sb" },
  { value: "Somalia", name: "Somalia", code: "so" },
  { value: "South Africa", name: "South Africa", code: "za" },
  { value: "South Korea", name: "South Korea", code: "kr" },
  { value: "South Sudan", name: "South Sudan", code: "ss" },
  { value: "Spain", name: "Spain", code: "es" },
  { value: "Sri Lanka", name: "Sri Lanka", code: "lk" },
  { value: "Sudan", name: "Sudan", code: "sd" },
  { value: "Suriname", name: "Suriname", code: "sr" },
  { value: "Sweden", name: "Sweden", code: "se" },
  { value: "Switzerland", name: "Switzerland", code: "ch" },
  { value: "Syria", name: "Syria", code: "sy" },
  { value: "Tajikistan", name: "Tajikistan", code: "tj" },
  { value: "Tanzania", name: "Tanzania", code: "tz" },
  { value: "Thailand", name: "Thailand", code: "th" },
  { value: "Timor-Leste", name: "Timor-Leste", code: "tl" },
  { value: "Togo", name: "Togo", code: "tg" },
  { value: "Tonga", name: "Tonga", code: "to" },
  { value: "Trinidad and Tobago", name: "Trinidad and Tobago", code: "tt" },
  { value: "Tunisia", name: "Tunisia", code: "tn" },
  { value: "Turkey", name: "Turkey", code: "tr" },
  { value: "Turkmenistan", name: "Turkmenistan", code: "tm" },
  { value: "Tuvalu", name: "Tuvalu", code: "tv" },
  { value: "Uganda", name: "Uganda", code: "ug" },
  { value: "Ukraine", name: "Ukraine", code: "ua" },
  { value: "United Arab Emirates", name: "United Arab Emirates", code: "ae" },
  { value: "United Kingdom", name: "United Kingdom", code: "gb" },
  { value: "United States", name: "United States", code: "us" },
  { value: "Uruguay", name: "Uruguay", code: "uy" },
  { value: "Uzbekistan", name: "Uzbekistan", code: "uz" },
  { value: "Vanuatu", name: "Vanuatu", code: "vu" },
  { value: "Vatican City", name: "Vatican City", code: "va" },
  { value: "Venezuela", name: "Venezuela", code: "ve" },
  { value: "Vietnam", name: "Vietnam", code: "vn" },
  { value: "Yemen", name: "Yemen", code: "ye" },
  { value: "Zambia", name: "Zambia", code: "zm" },
  { value: "Zimbabwe", name: "Zimbabwe", code: "zw" },
];
